import React from 'react';
import { IconSvgProps } from '@models/common';

const Lock: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'>
      <g fill='none'>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M3 12a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm10 2a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0z'
          clipRule='evenodd'
        />
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M8 10V7a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v3'
        />
      </g>
    </svg>
  );
};

export default Lock;
